/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_All_ReleasesInputs */

const en_pc_dl_all_releases = /** @type {(inputs: Pc_Dl_All_ReleasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Older versions and release notes`)
};

const zh_pc_dl_all_releases = /** @type {(inputs: Pc_Dl_All_ReleasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`历史版本与更新日志`)
};

/**
* | output |
* | --- |
* | "Older versions and release notes" |
*
* @param {Pc_Dl_All_ReleasesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_all_releases = /** @type {((inputs?: Pc_Dl_All_ReleasesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_All_ReleasesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_all_releases(inputs)
	return zh_pc_dl_all_releases(inputs)
});
export { pc_dl_all_releases as "pc.dl.all_releases" }